export default __webpack_public_path__ + "static/media/person.d617da27.svg";